import { Segment } from '@mairistem/composants';
import React from 'react';
import './TreeViewPlaceholder.css';

const TreeViewPlaceholder = () => (
	<Segment className="treeViewLoading" loading />
);

export default TreeViewPlaceholder;
